import { Controller } from "@hotwired/stimulus"
import { emojiBlast } from "emoji-blast"

export default class extends Controller {
  blast(event) {
    event.preventDefault()

    emojiBlast({
      emojis: ["🚀", "🎉", "🎵", "✨"],
      position: {
        x: event.clientX,
        y: event.clientY
      }
    })
  }
}
